<template>
  <div class="page settings-page">
    <div class="container">
      <div class="text-container">
        <h1>{{ appVocubulary.welcomeH1 }}</h1>
        <p v-html="appVocubulary.welcomeP"></p>
        <div class="interests">
          <input
            type="checkbox"
            id="match-everyone"
            v-model="matchAnyone"
            checked
          />
          <label for="match-everyone">{{ appVocubulary.anyone }}</label>
          <div>
            <h3>{{ appVocubulary.gender.question }}</h3>
            <div class="tags-container">
              <input
                type="radio"
                id="male-tag"
                name="gender"
                value="male"
                v-model="preferences.gender"
              />
              <label for="male-tag">{{ appVocubulary.gender.males }}</label>
              <input
                type="radio"
                id="female-tag"
                name="gender"
                value="female"
                v-model="preferences.gender"
              />
              <label for="female-tag">{{ appVocubulary.gender.females }}</label>
              <input
                type="radio"
                id="any-gender"
                name="gender"
                value="any"
                v-model="preferences.gender"
              />
              <label for="any-gender">{{ appVocubulary.gender.any }}</label>
            </div>
          </div>
          <div>
            <h3>{{ appVocubulary.country.question }}</h3>

            <div class="tags-container">
              <input
                type="radio"
                name="country"
                id="my-country-tag"
                value="my"
                v-model="preferences.country"
              />
              <label for="my-country-tag">{{ appVocubulary.country.my }}</label>
              <input
                type="radio"
                name="country"
                id="any-country-tag"
                value="any"
                v-model="preferences.country"
              />
              <label for="any-country-tag">{{
                appVocubulary.country.any
              }}</label>
            </div>
          </div>
          <div>
            <h3>{{ appVocubulary.interestsQuestion }}</h3>
            <div class="tags-container">
              <div v-for="(interest, key) in interestsVocubulary" :key="key">
                <input type="checkbox" :id="key" v-model="interests[key]" />
                <label :for="key">
                  {{ interest }}
                </label>
              </div>
              <div
                v-for="(movie, key) in movieInterestsVocubulary"
                :key="key"
                v-show="interests.movies"
              >
                <input
                  type="checkbox"
                  :id="'genre-' + key"
                  v-model="interests[key]"
                />
                <label :for="'genre-' + key">
                  {{ movie }}
                </label>
              </div>
            </div>
          </div>
          <button class="save" @click="updateUserPrefs">
            {{ appVocubulary.save }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Settings",
  data() {
    return {
      matchAnyone: true,
      preferences: {
        gender: "any",
        country: "any",
      },
      interests: {
        sports: false,
        music: false,
        technology: false,
        business: false,
        travelling: false,
        memes: false,
        anime: false,
        society: false,
        gaming: false,
        art: false,
        design: false,
        programming: false,
        movies: false,
        drama: false,
        action: false,
        horror: false,
        comedy: false,
        superhero: false,
      },
    };
  },
  computed: {
    thisUser() {
      return this.$store.state.user;
    },
    lang() {
      return this.$store.state.lang;
    },
    appVocubulary() {
      return this.$store.state.appVocubulary[this.lang].pages.Settings;
    },
    interestsVocubulary() {
      let interests = {
        ...this.$store.state.appVocubulary[this.lang].public.interests,
      };
      delete interests.everything;
      delete interests.announce;
      delete interests.question;
      return interests;
    },
    movieInterestsVocubulary() {
      return this.$store.state.appVocubulary[this.lang].public.movieInterests;
    },
  },
  beforeMount() {
    if (this.thisUser.name === "") {
      document.getElementById("login-link").click();
    }
  },
  mounted() {
    if (this.thisUser.interests) {
      for (let interest in this.interests) {
        if (this.thisUser.interests.includes(interest)) {
          this.interests[interest] = true;
        }
      }
    }
  },
  methods: {
    updateUserPrefs() {
      // convert interests object to an array
      let interestsArray = [];
      for (let interest in this.interests) {
        if (this.interests[interest]) {
          interestsArray.push(interest);
        }
      }
      // update the user in store with the new infos :
      this.$store.commit("setupUser", {
        origin: "settings",
        newData: {
          preferences: this.preferences,
          interests: interestsArray,
          matchAnyone: this.matchAnyone,
        },
      });

      document.getElementById("home-link").click();
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 60px;
}
html[lang="ar"] .interests {
  text-align: right;
}
html[lang="en"] .interests {
  text-align: left;
}

.interests {
  margin: 60px 0;
  padding: 0 10px;
  &.display-movies .movies-genres {
    display: inline-block;
  }
  .movies-genres {
    display: none;
  }

  button.save {
    border-radius: 40px;
    padding: 10px 20px;
    background-color: var(--accent);
    color: white;
    margin: 0 10px 20px;
  }

  .tags-container {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    margin: 20px 0;
    div {
      margin: 20px 0;
      &.movie-genre {
        display: none;
      }
    }
  }

  h3 {
    margin: 40px 0;
  }

  input[type="radio"],
  input[type="checkbox"] {
    display: none;
    &:checked + label {
      background-color: var(--accent);
      color: white;
    }
  }

  label {
    margin: 10px;
    padding: 10px 16px;
    font-weight: bold;
    color: var(--accent);
    border: 2px solid var(--accent);
    border-radius: 40px;
    font-size: 0.9em;
    cursor: pointer;
  }
}
</style>
